import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: '/home'
    }, {
        path: '/home',
        name: 'home',
        component: () => import('../views/homePage.vue')
    }, {
        path: '/service',
        name: 'loanService',
        component: () => import('../views/loanService.vue')
    }, {
        path: '/about',
        name: 'aboutUS',
        component: () => import('../views/aboutUS.vue')
    }, {
        path: '/contact',
        name: 'contactUS',
        component: () => import('../views/contactUS.vue')
    }, {
        path: '/privatePolicySanjviv',
        name: 'privatePolicySanjviv',
        component: () => import('../views/privatePolicySanjviv.vue')
    }, {
        path: '/loanAgreementSanjviv',
        name: 'loanAgreementSanjviv',
        component: () => import('../views/loanAgreementSanjviv.vue')
    }, {
        path: '/privatePolicyRupeeExpress',
        name: 'privatePolicyRupeeExpress',
        component: () => import('../views/privatePolicyRupeeExpress.vue')
    }, {
        path: '/loanAgreementRupeeExpress',
        name: 'loanAgreementRupeeExpress',
        component: () => import('../views/loanAgreementRupeeExpress.vue')
    }, {
        path: '/partner',
        name: 'partner',
        component: () => import('../views/partnerInformation.vue')
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router;
